import { useMatches } from 'react-router';

import type { WorkspaceFeature } from '@/config/workspace-features';

/** 라우트 handle 규약 — 레이아웃이 읽는 페이지 메타. */
export interface RouteHandle {
  /** 미니멀 헤더의 페이지 라벨(로그인 / 회원가입 …). */
  pageLabel?: string;
  /** 문서 타이틀·워크스페이스 상단바 제목. */
  title?: string;
  /**
   * 사업 연도와 무관한 화면 — 워크스페이스 상단 기준 연도 선택을 "연도 무관"으로 비활성한다(#198). 기본(미선언)은 연도 기반
   * — 신규 화면이 선언을 빠뜨려도 연도 선택이 막히지 않는 쪽이 안전하다.
   */
  yearIndependent?: boolean;
  /** 워크스페이스 화면이 속한 기능 — 세션 기능 목록에 없으면 `RequireRouteFeature` 가 막는다(specs/064). */
  feature?: WorkspaceFeature;
}

/** 가장 깊은 매치의 handle 을 병합해 반환(자식이 부모를 덮어쓴다). */
export function useRouteHandle(): RouteHandle {
  const matches = useMatches();
  return matches.reduce<RouteHandle>(
    (acc, m) => ({ ...acc, ...((m.handle as RouteHandle) ?? {}) }),
    {},
  );
}
